import ServiceFactory from '../../service_factory';
import {EventType, ILogEventHeader, ILogEventType} from '../interfaces/log-event-header.interface';
import DateFormatter from '../../../utils/date_formatter';
import {Check} from '@sparkware/app-utils';
import uuid from 'uuid/v4';


export class LogEventHeaderBuilder {
    constructor(private readonly services: ServiceFactory, private readonly _environment: string) {
    }

    build(level: string): ILogEventHeader {
        const headerData: ILogEventHeader = {
            clientDateTime: DateFormatter.formatCurrentDateToUtc(),
            correlationID: this._correlationID || uuid(),
            environment: this._environment,
            eventType: this._eventType,
            level: level,
            logVersionFormat: 2,
            target: this._target
        }

        if(this._appID) {
            headerData.appID = this._appID;
        }

        if(this._businessCorrelationID) {
            headerData.businessCorrelationID = this._businessCorrelationID;
        }
        if(this._productPackageID) {
            headerData.productPackageID = this._productPackageID;
        } else {
            headerData.productPackageID = this.services.skinService().getProductPackageID();
        }

        if(!Check.isNullOrUndefined(this._sequentialNumber)) {
            headerData.sequentialNumber = this._sequentialNumber;
        }

        if(this._sessionID) {
            headerData.sessionID = this._sessionID;
        }

        if(this.services.oAuth2Service().isAuthorized()) {
            let decodedToken = this.services.oAuth2Service().getToken();
            let skinService = this.services.skinService();
            //userData is here just for backward compatibility with the log v1
            headerData.userData = {
                cid: parseInt(decodedToken.cid),
                brand: skinService.getBrandName()
            };
        }

        return headerData;
    }

    private _target = 'casino-orbit';

    setTarget(target): void {
        this._target = target;
    }

    private _correlationID: string = null;
    setCorrelationId(correlationID: string): void {
        this._correlationID = correlationID;
    }

    private _businessCorrelationID: string = null;
    setBusinessCorrelationID(businessCorrelationID: string): void {
        this._businessCorrelationID = businessCorrelationID;
    }

    private _sessionID: string = null;
    setSessionID(sessionID: string): void {
        this._sessionID = sessionID;
    }

    private _appID: string = 'CASINO_CLIENT';
    setAppID(appID: string): void {
        this._appID = appID;
    }

    _productPackageID: number = null;
    setProductPackageID(productPackageID: number): void {
        this._productPackageID = productPackageID;
    }

    _sequentialNumber: number = null;
    setSequentialNumber(sequentialNumber: number): void {
        this._sequentialNumber = sequentialNumber;
    }

    private _eventType: ILogEventType = {
        name: 'CGP_GENERIC_EVENT',
        type: ['Log']
    }

    setEventType(eventName: string, ...eventTypes: EventType[]): this {
        if(!eventTypes || eventTypes.length === 0) {
            eventTypes = ['Log'];
        }
        this._eventType = {
            name: eventName,
            type: eventTypes
        };

        return this;
    }
}
